var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFortinet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fortinet__Integration=Fortinet, Size=24",
    className: "fortinet__Integration=Fortinet, fortinet__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fortinet__Vector",
    fill: "#DA291C",
    d: "M23 10.028v3.974h-6.191v-3.974H23ZM8.919 19.674h6.191v-3.973H8.919v3.973ZM23 7.666a3.343 3.343 0 0 0-3.34-3.34h-2.851V8.3H23v-.634ZM8.919 4.326V8.3h6.191V4.326H8.919ZM1 10.028v3.974h6.191v-3.974H1Zm15.809 9.646h2.85A3.343 3.343 0 0 0 23 16.334v-.633h-6.191v3.973ZM1 16.334a3.343 3.343 0 0 0 3.34 3.34h2.851v-3.973H1v.633Zm0-8.668V8.3h6.191V4.326h-2.85A3.343 3.343 0 0 0 1 7.666Z",
    className: "fortinet__Vector"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortinet);
export default __webpack_public_path__ + "static/media/Fortinet.1f612a0bf77565f08a35d39520ff925c.svg";
export { ForwardRef as ReactComponent };